import gql from 'graphql-tag';

import {Name} from 'web-app/react/staffing-attendance/graphql/fragment/generics/name.fragment';

import {TfcBalance} from './tfc-balance.fragment';

export const TaxFreeChildcareChild = gql`
    fragment TaxFreeChildcareChild on TaxFreeChildcareChild {
        account {
            balance {
                ...TfcBalance
            }
            referenceId
            linkedBy {
                currentUser
            }
        }
        billPayerId
        siteSetId
        child {
            id
            birthday
            name {
                ...Name
            }
            profileImage {
                url
            }
        }
    }
    ${TfcBalance}
    ${Name}
`;
